<template>
  <ul class="main-footer__nav">
    <template v-for="item in menu">
      <li v-if="item.parent === '0'" :key="item.id" :title="item.title" :class="item.class">
        <router-link :to="$root.convertToRelative(item.url)" v-html="item.content" :target="item.target">
        </router-link>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'footer-menu',
  data() {
    return {
      menu: this.$store.getters.menu({ name: this.name })
    }
  },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    acf_options() {
      return this.$store.getters.acfOptions()
    },
  },
  beforeMount() {

  }
}
</script>
